// extracted by mini-css-extract-plugin
module.exports = {"footerBtm":"footer_footerBtm__1sefV","desktopFooter":"footer_desktopFooter__1dPuR"};